import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop fade show"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header flex-stack" }
const _hoisted_4 = { class: "svg-icon svg-icon-1" }
const _hoisted_5 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_6 = { class: "w-100 h-450px" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_9 = ["href"]

import {computed, ref} from "vue";
import { useI18n } from "vue-i18n/index";
import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const store = useStore();

const modal = ref<HTMLElement | null>(null);
const show = ref<boolean>(false);

const videoUrl = ref<string | null>(null);
const lessonUrl = ref<string | null>(null)

const modalTitle = ref("Machine Write-Up")

const { t } = useI18n();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

const showModal = (url, lesson_url, title) => {
  if (modal.value) {
    modal.value.style.display = "block";
    modal.value.classList.add("show");
    modal.value.setAttribute("aria-modal", "true");
    modal.value.setAttribute("role", "dialog");

    videoUrl.value = url;
    lessonUrl.value = lesson_url;

    modalTitle.value = title || "Machine Write-Up";

    show.value = true;
  }
};

const hideModal = () => {
  if (modal.value) {
    modal.value.style.display = "none";
    modal.value.classList.remove("show");
    modal.value.removeAttribute("aria-modal");
    modal.value.removeAttribute("role");

    videoUrl.value = null;
    lessonUrl.value = null;

    modalTitle.value = "Machine Write-Up";

    show.value = false;
  }
};

expose({
  showModal
})


return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "modal fade",
      tabindex: "-1",
      ref_key: "modal",
      ref: modal,
      onClick: hideModal
    }, [
      _createElementVNode("div", {
        class: "modal-dialog modal-dialog-centered mw-850px",
        onClick: _cache[0] || (_cache[0] = _withModifiers(()=>{}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(modalTitle.value), 1),
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              onClick: hideModal
            }, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("iframe", {
                style: {"width":"100%","height":"100%","border-radius":"10px"},
                class: "video-js vjs-theme-forest h-100 w-100",
                src: videoUrl.value,
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: ""
              }, null, 8, _hoisted_7)
            ]),
            (lessonUrl.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("a", {
                    href: lessonUrl.value,
                    class: "btn btn-primary mt-5",
                    target: "_blank"
                  }, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.machine.go_to_lesson`)), 9, _hoisted_9)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})